import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UnitTypeFilterSchema } from '../types';
import { UnitType } from 'entities/Contract';

const initialState: UnitTypeFilterSchema = {
  selectedFilter: UnitType.BOX,
};

const unitTypeFilterSlice = createSlice({
  name: 'unitTypeFilter',
  initialState,
  reducers: {
    changeFilter: (state: UnitTypeFilterSchema, action: PayloadAction<UnitType>) => {
      state.selectedFilter = action.payload;
    },
    resetFilter: (state: UnitTypeFilterSchema) => {
      state.selectedFilter = UnitType.BOX;
    },
  },
});

export const { actions: unitTypeFilterActions, reducer: unitTypeFilterReducer } = unitTypeFilterSlice;
